
import LeftNav from './LeftNav/index.vue'
import TopNav from './TopNav.vue'
import CertificationBar from '@/components/CertificationBar.vue'
import Vuex from '@/store'
import { $t as lang } from '@/Tool'
import { defineComponent, ref, computed, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import vuex from '@/store'
import service from '@/services'
import { SystemMessage } from '@/Tool/LoginSet'

export default defineComponent({
  name: 'GuijiLayout',
  components: {
    LeftNav,
    TopNav,
    CertificationBar,
  },
  setup() {
    const isCollapse = computed(() => Vuex.state.leftMenuCollapse)
    const systemMessage = computed(() => vuex.state.systemMessage)
    let isEditorPage = ref(false)
    let isBatchVideo = ref(false)
    let isPictureSpeaker = ref(false)
    let isAiKnowledge = ref(false)
    const is3Part = 'true' === sessionStorage.getItem('is3Part')

    // 跑马灯动画控制
    const marqueeSpeed = computed(() => {
      const content = systemMessage.value.announcement?.content || ''
      // 根据内容长度调整动画速度
      if (content.length < 20) return '25s'
      if (content.length < 50) return '35s'
      return '45s'
    })

    function handleCloseBroadCastMessage() {
      const FuncSystemMessage = new SystemMessage({})
      service.MessageApi.saveMessageRecord({
        data: {
          messageIds: [vuex.state.systemMessage.announcement.id],
        },
      }).then(() => {
        FuncSystemMessage.getMessageInfo(vuex.state.user.info.userId)
        vuex.commit('set_data', {
          checkedBroadcastId: vuex.state.systemMessage.announcement.id,
        })
        location.reload()
      })
    }
    const route = useRoute()
    watchEffect(() => (isEditorPage.value = route.path.includes('create/video')))
    watchEffect(() => (isBatchVideo.value = route.path.includes('batch/synthesis')))
    watchEffect(() => (isPictureSpeaker.value = route.path.includes('createChatImageVideo')))
    watchEffect(() => (isAiKnowledge.value = route.path.includes('aiKnowledge')))
    return {
      isCollapse,
      isEditorPage,
      isBatchVideo,
      isPictureSpeaker,
      isAiKnowledge,
      is3Part,
      systemMessage,
      marqueeSpeed,
      handleCloseBroadCastMessage,
      lang,
    }
  },
})
